<ng-template #iconButtons>
	<div data-cy="search-icon" *ngIf="this.userPermissions.forms.admin" class="icon-badge-wrapper" title="Search">
		<i (click)="handleGotoSearchClick()" class="pi pi-search icon-with-badge cursor-pointer"></i>
	</div>

	<ng-container *ngIf="currentProperty?.isPhobosEnabled && currentProperty?.id as pid">
		<app-is-ai-tasks-processing
			[propertyId]="pid"
			[activeColor]="'red'"
			[iconSizeClass]="'text-2xl'">
		</app-is-ai-tasks-processing>
	</ng-container>

	<div class="icon-badge-wrapper" title="Outstanding Tasks">
		<i (click)="handleOutstandingTasksClick()" class="pi pi-cog text-2xl cursor-pointer">
			<span *ngIf="outstandingCount > 0" class="badge">{{ outstandingCount }}</span>
		</i>
	</div>

	<div class="icon-badge-wrapper" title="Mentions">
		<a [queryParams]="{ tab: 'mentions' }" [routerLink]="['/dashboard']">
			<i class="pi pi-envelope icon-with-badge">
				<span *ngIf="mentionCount > 0" class="badge">{{ mentionCount }}</span>
			</i>
		</a>
	</div>
</ng-template>

<div class="layout-topbar py-0">
	<div class="layout-topbar-wrapper">
		<div class="layout-topbar-left">
			<div class="flex flex-wrap w-full ">
				<div class="ml-0">
					<div id="logolink" routerLink="/" style="cursor: pointer; outline: none">
						<img
							alt="tyalls"
							height="40"
							id="app-logo"
							ngSrc="https://tyalls-images.s3.ap-southeast-2.amazonaws.com/app/logo/Tyalls_CMYK_logo_default.svg"
							priority
							width="100"
						/>
					</div>
				</div>
			</div>
			<div class="flex gap-5" style="margin-left:50px">
				<div class="align-items-center mr-3 gap-5 icon-button-bar-for-large-screens">
					<ng-container *ngTemplateOutlet="iconButtons"></ng-container>
				</div>
				<app-current-property-drop-down></app-current-property-drop-down>
			</div>
		</div>

		<div class="layout-topbar-right">
			<div></div>
			<div class="menu-items flex align-items-center">
				<div class="align-items-center mr-3 gap-5 icon-button-bar-for-small-screens">
					<div *ngIf="showTrialBadge" class="trial-badge" [class.grace]="isGracePeriod">
						<i class="pi pi-clock mr-1"></i>

						<ng-container [ngSwitch]="trialPhase">
    <span *ngSwitchCase="'TRIAL'">
      {{ daysRemaining }} days left of {{ environment.trialDays }}
    </span>

							<span *ngSwitchCase="'GRACE'">
      Grace period — {{ graceDaysRemaining }} days remaining — <a [routerLink]="environment.supportLinks.billingSetup" class="billing-link">
			Go to Billing Setup →
		</a>
    </span>
						</ng-container>
					</div>
					<ng-container *ngTemplateOutlet="iconButtons"></ng-container>
				</div>
				<p-menubar [model]="mainMenuItems" class="p-menubar-responsive"></p-menubar>
			</div>
		</div>
	</div>
</div>

<!-- ======================================= -->
<!--   TRIAL BANNER NOW SITS OUTSIDE TOPBAR  -->
<!-- ======================================= -->
<div *ngIf="showTrialNotice" class="trial-banner">
	<div class="trial-banner-text">
		<span class="bold">{{ daysRemaining }} days left in your trial.</span>
		<span class="message">
			Please complete your billing setup to continue using Tyalls after your trial.
		</span>

		<a [routerLink]="environment.supportLinks.billingSetup" class="billing-link">
			Go to Billing Setup →
		</a>
	</div>

	<button class="banner-close" (click)="dismissTrialNotice()">
		<i class="pi pi-times"></i>
	</button>
</div>
<!-- ======================== TRIAL NOTIFICATION END ========================== -->

	<!-- ======================== GRACE PERIOD MODAL ======================== -->
	<p-dialog
		[(visible)]="showGraceModal"
		[autoZIndex]="true"
		[baseZIndex]="90000"
		[closable]="false"
		[modal]="true"
		[style]="{ width: '60rem' }"
		class="grace-modal"
	>
		<!-- HEADER -->
		<ng-template pTemplate="header">
			<div class="dialog-header">
				<strong>Thank you for trying Tyalls!</strong>
			</div>
		</ng-template>

		<div class="grace-container">
			<!-- LEFT -->
			<div class="grace-left">

				<p class="intro-text">
					Your 14-day trial has ended, but we’ve given you an additional
					<strong>{{ environment.trialGracePeriodDays }}-day grace period</strong>
					so you can continue exploring Tyalls.
				</p>

				<p class="grace-warning">
					You have <strong>{{ graceDaysRemaining }}</strong> days left before your account is locked.
				</p>

				<p class="sub-text">
					To keep using Tyalls without interruption, please complete your billing setup.
				</p>

				<!-- BUTTON ROW -->
				<div class="button-row">
					<button
						pButton
						pRipple
						label="Complete Billing Setup"
						class="p-button-raised p-button-primary w-fit"
						(click)="goToBillingSetup()"
					></button>

					<button
						pButton
						pRipple
						label="I will not continue"
						class="p-button-danger p-button-outlined w-fit"
						(click)="onDeclineContinue()"
					></button>

					<button
						pButton
						pRipple
						label="Continue with Grace Period"
						class="p-button-outlined w-fit"
						(click)="closeGraceModal()"
					></button>
				</div>
			</div>

			<!-- RIGHT IMAGE -->
			<div class="grace-right">
				<img
					src="assets/images/onboarding-celebration.png"
					alt="Grace Illustration"
					class="illustration"
				/>
			</div>
		</div>
	</p-dialog>
	<!-- ======================== END GRACE PERIOD MODAL ======================== -->




